export const GET_DRAFT_STATUS_LIST = "GET_DRAFT_STATUS_LIST";

export const DRAFT_LIST_ACTION = "DRAFT_LIST_ACTION";
export const DRAFT_WRITE_ACTION = "DRAFT_WRITE_ACTION";
